import { EPermissions } from '@/types/permissions.types';
import { Put } from '../helpers';
import { createPath } from './utils';

export function ReplaceUserAccess(channel: number, email: string, statements: string[], roles: EPermissions[]) {
  return Put<{ message: string }>({
    path: createPath(`${channel}/user`),
    body: {
      email,
      statements,
      roles,
    },
  });
}

type ReplaceUserAccessBulkPayload = {
  email: string;
  statements: string[];
  roles: EPermissions[];
}[];
export function ReplaceUserAccessBulk(channel: number, payload: ReplaceUserAccessBulkPayload) {
  return Put<{ message: string }>({
    path: createPath(`${channel}/bulk`),
    body: payload,
  });
}
